<script>
	import { createEventDispatcher } from 'svelte';
	import { tweened } from 'svelte/motion';
	import { cubicOut } from 'svelte/easing';
	import { interpolateNumber } from 'd3-interpolate'
  import { slide } from 'svelte/transition';
  import { onMount } from 'svelte';
  export let title;
  export let visible = [];
  export let id = 0;

  const progress = tweened(0, {
    duration: 400,
    easing: cubicOut
  });

  const y1 = interpolateNumber(6, -2)
  const y2 = interpolateNumber(-2, 6)

	const dispatch = createEventDispatcher();

	$: isVisible = visible[id]

  function handleClick (event) {
		dispatch('toggle', {
			visible: !isVisible,
			id
		});
		progress.set(!isVisible ? 0 : 1)
	}

	onMount(() => {
		progress.set(isVisible ? 0 : 1)
	})

	$: {
		progress.set(isVisible ? 0 : 1)
	}
</script>

<div class="collapse">
	<div
		class="collapse-title link"
		class:isActive={isVisible}
		role="switch"
    aria-checked={String(isVisible)}
    aria-label={`Click to ${isVisible ? 'hide' : 'show'} the text`}>
		<h3 on:click={handleClick} class="label">{ title }</h3>
		<svg class="senses-falafel" viewBox="0 0 20 20">
	    <g transform="translate(10 10)">
	      <path d={`M-7 ${y1($progress)} L 0 ${y2($progress)} L 7 ${y1($progress)} Z`} />
	    </g>
	  </svg>
	</div>
	{#if isVisible}
	<p transition:slide aria-hidden={String(!isVisible)}>
		<slot />
	</p>
	{/if}
</div>